export const headers = [
  'Client',
  'Campaign',
  'Type',
  'Duration(W)',
  'Missions',
  'Rating',
  'User',
  'Date',
  'Feedback',
  'Tags',
]



// WEBPACK FOOTER //
// ./src/Containers/Settings/NetPromoterScore/options.js